import { Column } from 'src/app/model/common/column';

export const CONTROLLER_NOTES_SEARCH_TABLE_DEFINITION: Column[] = [
  {
    field: 'updatedAt',
    header: 'CRM.LABEL.CREATED_UPDATED_AT',
    mobileHeader: 'CRM.LABEL.CREATED_UPDATED_AT',
    formatPattern: 'calendar',
    type: 'calendar',
    width: '7%',
    sortable: true,
    filterable: false,
    matchMode: 'contains',
    dateFormat: 'yyyy-MM-dd hh:mm aaa',
  },
  {
    field: 'AORName',
    header: 'LOCATION.LABEL.AOR',
    mobileHeader: 'LOCATION.LABEL.AOR',
    formatPattern: 'text',
    type: 'input',
    width: '10%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'category',
    header: 'CRM.LABEL.CATEGORY',
    mobileHeader: 'CRM.LABEL.CATEGORY',
    formatPattern: 'text',
    type: 'input',
    width: '7%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'noteType',
    header: 'CRM.LABEL.NOTE_TYPE',
    mobileHeader: 'CRM.LABEL.NOTE_TYPE',
    formatPattern: 'text',
    type: 'input',
    width: '10%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'facilityOrPipelineNum',
    header: 'LOCATION.LABEL.FACILITY_NAME',
    mobileHeader: 'LOCATION.LABEL.FACILITY_NAME',
    formatPattern: 'text',
    type: 'input',
    width: '10%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'facilityScadaId',
    header: 'LOCATION.LABEL.SCADA_ID',
    mobileHeader: 'LOCATION.LABEL.SCADA_ID',
    formatPattern: 'text',
    type: 'input',
    width: '5%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
  {
    field: 'firstEntry',
    header: 'CRM.LABEL.NOTES',
    mobileHeader: 'CRM.LABEL.NOTES',
    formatPattern: 'text',
    type: 'input',
    width: '51%',
    sortable: true,
    filterable: true,
    matchMode: 'contains',
  },
];
